import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ContextItem, RequirementContextType } from "../../../../types";
import { ISharedFileRequestResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";
import { getSharedFileRequirementStatus } from "./getSharedFileRequirementStatus";

export const getSharedFilePayeeRequirementStatus = (
  requirement: IRequirementResponse,
  contextItem: ContextItem,
  sharedFile: ISharedFileRequestResponse | undefined
) => {
  return getSharedFileRequirementStatus(
    requirement,
    contextItem,
    sharedFile,
    RequirementContextType.Payer
  );
};
